import React from 'react';

const NUMBER_ROW = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
const ROW_1 = ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'];
const ROW_2 = ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'];
const ROW_3 = ['Z', 'X', 'C', 'V', 'B', 'N', 'M'];

/**
 * Minimal on-screen QWERTY + numbers keyboard for the kiosk search bar.
 * Fully controlled - writes into the SAME search state via onChange, never
 * owns its own query/search logic (reuses the existing search behaviour).
 */
export default function KioskSearchKeyboard({ value, onChange, onClose }) {
  // Prevent key taps from blurring the search input (avoids flicker/refocus).
  const stopFocusSteal = (e) => e.preventDefault();

  const press = (char) => onChange((value || '') + char);
  const backspace = () => onChange((value || '').slice(0, -1));
  const space = () => onChange((value || '') + ' ');
  const clear = () => onChange('');

  return (
    <div className="kiosk-search-keyboard" onMouseDown={stopFocusSteal}>
      <div className="ksk-row">
        {NUMBER_ROW.map((k) => (
          <button key={k} type="button" className="ksk-key" onClick={() => press(k)}>{k}</button>
        ))}
      </div>
      <div className="ksk-row">
        {ROW_1.map((k) => (
          <button key={k} type="button" className="ksk-key" onClick={() => press(k)}>{k}</button>
        ))}
      </div>
      <div className="ksk-row ksk-row-indent">
        {ROW_2.map((k) => (
          <button key={k} type="button" className="ksk-key" onClick={() => press(k)}>{k}</button>
        ))}
      </div>
      <div className="ksk-row">
        {ROW_3.map((k) => (
          <button key={k} type="button" className="ksk-key" onClick={() => press(k)}>{k}</button>
        ))}
        <button type="button" className="ksk-key ksk-key-wide" onClick={backspace}>⌫</button>
      </div>
      <div className="ksk-row">
        <button type="button" className="ksk-key ksk-key-wide" onClick={clear}>Clear</button>
        <button type="button" className="ksk-key ksk-key-space" onClick={space}>Space</button>
        <button type="button" className="ksk-key ksk-key-wide" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
